const CORESP = [
  // Home
  {
    resource: 'home',
    routeName: 'Dashboard'
  },
  // Lots
  {
    resource: 'lot',
    actions: [
      {
        name: 'display',
        routeName: 'LotVue',
        needParam: [
          ['pk', 'id']
        ]
      }
    ]
  },
  // Contacts
  {
    resource: 'contact',
    actions: [
      {
        name: 'display',
        routeName: 'ContactVue',
        needParam: [
          ['pk', 'id']
        ]
      }
    ]
  },
  // Option
  {
    resource: 'option',
    actions: [
      {
        name: 'list',
        routeName: 'OptionList'
      },
      {
        name: 'display',
        routeName: 'OptionList',
        needParam: []
      }
    ]
  },
  // ADV
  {
    resource: 'adv',
    actions: [
      {
        name: 'display',
        routeName: 'AdvInfos',
        needParam: [
          ['pk', 'id']
        ]
      }
    ]
  },
  // Denunciation
  {
    resource: 'denunciation',
    actions: [
      {
        name: 'display',
        routeName: 'DenunciationList',
        needParam: []
      }
    ]
  },
  // Rdv
  {
    resource: 'rdv',
    actions: [
      {
        name: 'display',
        routeName: 'CalendarDayView',
        needParam: [
          ['day', 'day'],
          ['month', 'month'],
          ['year', 'year']
        ]
      }
    ]
  },
  {
    resource: 'reminder',
    actions: [
      {
        name: 'display',
        routeName: 'CalendarDayView',
        needParam: [
          ['day', 'day'],
          ['month', 'month'],
          ['year', 'year']
        ]
      }
    ]
  },
  // Lead
  {
    resource: 'lead',
    actions: [
      {
        name: 'display',
        routeName: 'LeadVue',
        needParam: [
          ['pk', 'id']
        ]
      }
    ]
  },
  {
    resource: 'login',
    actions:[
      {
        name: 'display',
        routeName: 'ResetPassword',
        needParam: [
          ['token', 'token'],
          ['email', 'email'],
          ['mode', 'mode']
        ]
      }
    ]
  }
]

module.exports = CORESP



//////////////////
// WEBPACK FOOTER
// ./config/runtimeConf/redirectConfig.js
// module id = ghC6
// module chunks = 1